import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type StudentEventsService from 'district-ui-client/services/student-events'
import type { DistrictScope, SchoolScope } from 'district-ui-client/utils/student-events/stats-scope'

export interface TimeOnTaskHistoryDistrictResponse {
  schools: {
    school_id: number
    name: string
    student_count: number
    session_count: number
    total_seconds: number
    average_seconds_per_week: number
    average_seconds_per_session: number
  }[]
  district: {
    student_count: number
    total_seconds: number
    average_seconds_per_week: number
    average_seconds_per_session: number
    session_count: number
  }
}

export interface TimeOnTaskHistorySchoolResponse {
  students: {
    student_id: number
    total_seconds: number
    average_seconds_per_week: number
    session_count: number
    average_seconds_per_session: number
  }[]
}

export async function timeOnTaskHistoryDistrict(
  this: StudentEventsService,
  product: LegacyProductRe | LegacyProductRex | LegacyProductMs,
  statsScope: DistrictScope,
  period: NormalizedInterval,
): Promise<Nullable<TimeOnTaskHistoryDistrictResponse>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('time_on_task_history', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<TimeOnTaskHistoryDistrictResponse>(url, query)
  if (!data) return null

  if (statsScope.scope === 'district' && data.schools.length === 0) return null

  return data
}

export async function timeOnTaskHistorySchool(
  this: StudentEventsService,
  product: LegacyProductRe | LegacyProductRex | LegacyProductMs,
  statsScope: SchoolScope,
  period: NormalizedInterval,
): Promise<Nullable<TimeOnTaskHistorySchoolResponse>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('time_on_task_history', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<TimeOnTaskHistorySchoolResponse>(url, query)
  if (!data) return null

  if (statsScope.scope === 'school' && data.students.length === 0) return null

  return data
}
